<template>
  <v-app v-if="breadcrumblist.length>0">
    <v-breadcrumbs :items="breadcrumblist" dense item-text="name">
      <template v-slot:divider>
        <v-icon>forward</v-icon>
      </template>
    </v-breadcrumbs>
  </v-app>
</template>
<script>
export default {
  name: "miga",
  data() {
    return {
      breadcrumblist: []
    };
  },
  mounted() {
    this.updatelist();
  },
  watch: {
    $route() {
      this.updatelist();
    }
  },
  computed: {},
  methods: {
    updatelist() {
      this.breadcrumblist = [];
      let lista2 = localStorage.parametros;
      if (lista2 === undefined)
        localStorage.setItem("parametros", JSON.stringify([]));
      if (this.$route.meta.breadcrumb !== undefined) {
        for (var i = 0; i < this.$route.meta.breadcrumb.length; i++) {
          if (this.$route.meta.breadcrumb[i].href !== undefined) {
            let to = this.$route.meta.breadcrumb[i].href;
            let lista = localStorage.parametros;
            if (lista !== undefined) {
              lista = JSON.parse(unescape(lista));
              for (var y in lista) {
                let obj = lista[y];
                let buscar = ":" + obj.nombre;
                to = to.replace(buscar + "?", obj.valor);
                to = to.replace(buscar, obj.valor);
              }
              let text = this.$route.meta.breadcrumb[i].text;
              if (to === "PATHFROM") {
                to = localStorage.pathfrom;
                text = localStorage.titlefrom;
              }
              this.breadcrumblist.push({
                text: text,
                to: to
              });
            }
          } else {
            let text2 = this.$route.meta.breadcrumb[i].text;
            if (text2 === "{{Reporte}}") {
              text2 = localStorage.reporte;
            }
            this.breadcrumblist.push({
              text: text2
            });
          }
        }
      }
    }
  }
};
</script>
